import { useEffect } from "react";
import { Provider } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./App.scss";
import Dashboard from "./components/Dashboard";
import FileLoginDetails from "./components/FileLoginDetails";
import FloatingNotification from "./components/FloatingNotification";
import Header from "./components/Header";
import Home from "./components/Home";
import InstallButton from "./components/InstallButton";
import LoanApplicationForm from "./components/LoanApplicationForm";
import Login from "./components/Login";
import PrivateOutlet from "./components/PrivateOutlet";
import UserDashboard from "./components/UserDashboard";
import UserForm from "./components/UserForm";
import { store } from "./store/store";
import ImageManager from "./components/ImageManager";

function App() {
  useEffect(() => {
    // Add Font Awesome
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <FloatingNotification />
        <div className="App">
          <Header />
          <div className="content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/pwa" element={<InstallButton />} />
              <Route path="/" element={<PrivateOutlet />}>
                <Route index element={<Navigate to="/home" replace />} />
                <Route path="home" element={<Home />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="file-login/:id" element={<FileLoginDetails />} />
                <Route
                  path="loan-application"
                  element={<LoanApplicationForm />}
                />
                <Route path="users" element={<UserDashboard />} />
                <Route path="images/manage" element={<ImageManager />} />

                <Route path="users/new" element={<UserForm />} />
                <Route path="users/:userId" element={<UserForm />} />
              </Route>
            </Routes>
          </div>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
